import { render, staticRenderFns } from "./addwxPay.vue?vue&type=template&id=38f4fa4e"
import script from "./addwxPay.vue?vue&type=script&lang=js"
export * from "./addwxPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports